<template>
    <div class="panels-columns">
        <geofence-list v-model="selectedGeofence"></geofence-list>
        <geofence-editor :geofence="selectedGeofence"></geofence-editor>

        <div class="map-and-console-container">
            <regions-map></regions-map>
            <console :lines="consoleLines"></console>
        </div>
    </div>
</template>

<script>
import GeofenceEditor from './GeofenceEditor.vue';
import RegionsMap from './RegionsMap.vue';

import GeofenceList from './GeofenceList.vue';
import Console from './Console.vue';

import geofences from "@/geofences.js";
import console from "@/console.js";

export default {
    name: 'Panels',
    computed: {
        consoleLines() { return console.lines; },
        selectedGeofence: {
            get() {
                return window.bus.selectedGeofence;
            },
            set(value) {
                window.bus.selectedGeofence = value;
            }
        }
    },
    data() {
        return { };
    },
    components: { GeofenceEditor, RegionsMap, GeofenceList, Console }
}
</script>

<style scoped lang="less">
.panels-columns
{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    box-sizing: border-box;
    min-height: 0;
    overflow: hidden;

    div:nth-child(1)
    {
        flex: 1;
        border-right: 1px solid silver;
    }

    div:nth-child(2)
    {
        flex: 2;
        border-right: 1px solid silver;
    }
}
.map-and-console-container
{
    display: flex;
    flex-direction: column;
}
.console-container
{
    flex: 1;
    overflow: auto;
}
</style>
